import { injectable, inject } from 'inversify';
import { NavigationEvent } from '@/app/statistics/events/navigation-events';
import { SectionStatusEvent } from '@/app/statistics/events/section-status-events';
//import { InteractionEvent } from '@/app/statistics/events/interaction-events';
//import { QuestionEvent } from '@/app/question/events/question-events';
import { SectionStateProjection } from '@/app/section-state/tracking/projection';
//import { InteractionStateProjection } from '@/app/interaction/tracking/projection';
// import { QuestionStateProjection } from '@/app/question/tracking/projection';
import { BookmarkStateProjection } from '@/app/bookmark/tracking/projection';

// TODO: OBSOLETE
@injectable()
export class TinCanEventHandler {

  constructor(
    @inject(SectionStateProjection)
    private readonly sectionState: SectionStateProjection,
    @inject(BookmarkStateProjection)
    private readonly navigationState: BookmarkStateProjection,
    // @inject(InteractionStateProjection)
    // private interactionState: InteractionStateProjection,
    // @inject(QuestionStateProjection)
    // private questionState: QuestionStateProjection
) {
  }

  public async handleEvent(event: any): Promise<boolean> {

    let handled = await this.sectionState.handle(event as (NavigationEvent | SectionStatusEvent));
    handled = await this.navigationState.handle(event as NavigationEvent) || handled;
//    handled = await this.interactionState.handle(event as InteractionEvent) || handled;
//    handled = await this.questionState.handle(event as QuestionEvent) || handled;

    return handled;
  }

  public async queryBookmark() {
    return await this.navigationState.currentBookmark();
  }
}
